import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Tooltip } from '@mui/material'
import { getDate } from 'common/utils/DateUtil'
import { PASTEL_COLOR } from 'common/utils/ColorUtil'
import { dueDateColor, statusColor, statusLabel, textOn } from './LotsUtils'

// Chip de statut (pastille + libellé) réutilisant les couleurs du lexique.
const StatusChip = ({ statut }) => {
    const c = statusColor(statut)
    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', px: 1, py: '3px', borderRadius: '2px', backgroundColor: c, color: textOn(c), fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap' }}>
            {statusLabel(statut)}
        </Box>
    )
}
StatusChip.propTypes = { statut: PropTypes.number }

// Date d'échéance : texte blanc dans une pastille rouge si dépassée, texte orange à moins de 7 jours.
const DueDate = ({ lot, sx = {} }) => {
    const color = dueDateColor(lot)
    const isOverdue = color === PASTEL_COLOR.red
    return (
        <Box
            component='span'
            sx={{
                fontWeight: color ? 700 : undefined,
                color: isOverdue ? 'white' : color,
                ...(isOverdue ? { backgroundColor: color, borderRadius: '10px', px: 0.75, py: '1px' } : {}),
                ...sx,
            }}
        >
            {getDate(lot.echeance)}
        </Box>
    )
}
DueDate.propTypes = { lot: PropTypes.shape({ echeance: PropTypes.number }), sx: PropTypes.shape({}) }

const MissingBcIcon = () => (
    <Tooltip title='Pas de bon de commande'>
        <Icon fontSize='small' sx={{ color: '#f39c12' }}>warning</Icon>
    </Tooltip>
)

export { StatusChip, MissingBcIcon, DueDate }
